<template>
  <div class="container-with-side clearfix" :style="containerStyle">
    <aside class="mb-3 mb-xl-0" :style="sidebarStyle">
      <slot name="sidebar"></slot>
    </aside>
    <div><slot name="content"></slot></div>
  </div>
</template>

<script>
export default {
  props: {
    sidebarOffset: {
      type: String,
      default: '430px'
    },
    sidebarWidth: {
      type: String,
      default: '330px'
    }
  },

  computed: {
    containerStyle() {
      return {
        paddingLeft: this.sidebarOffset
      };
    },

    sidebarStyle() {
      return {
        marginLeft: `-${this.sidebarOffset}`,
        width: this.sidebarWidth
      };
    }
  }
};
</script>

<style lang="scss" scoped>
aside {
  float: left;
  max-width: 100%;
}

@include media-breakpoint-down(md) {
  .container-with-side {
    padding-left: 0 !important;
  }

  aside {
    margin-left: 0 !important;
    float: none;
    width: 100% !important;
  }
}
</style>
